<form #scaleForm="ngForm" class="stewards-modal">
  <div class="modal-header stewards-modal-header">
    <h4 class="modal-title text-truncate">Fixture Stewards</h4>
    <button type="button" class="stewards-modal-close" (click)="cancel('cancel')" aria-label="Close">
      <fa name="times"></fa>
    </button>
  </div>
  <div class="modal-body stewards-modal-body">
    <div class="row">
      <div class="col">
        <div class="form-group mb-0">
          <label class="stewards-modal-label" for="fixtureOfficials">Stewards</label>
          <textarea class="form-control textarea-height" id="fixtureOfficials" name="fixtureOfficials" [(ngModel)]="officialsText"></textarea>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!meta.saving" class="modal-footer stewards-modal-footer">
    <button type="button" class="btn btn-outline-secondary stewards-modal-btn-close" (click)="cancel('cancel')">Close</button>
    <button type="button" class="btn btn-primary" [disabled]="!officialsText.length" (click)="confirm()">Confirm</button>
  </div>
  <div *ngIf="meta.saving" class="modal-footer stewards-modal-footer stewards-modal-footer-loading">
    <fa name="circle-o-notch" animation="spin"></fa>
  </div>
</form>
